<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>주요시공사
                            </h3>
                            <div class="h6 mt-4" style="font-size: 20px;">
                                고객에게 최상의 <span style="color:#2DB400">편안함</span>을 선사하는 다옴토건의 <span style="color:orange">기술력</span>과 <span style="color:orange">시공능력</span>을 자랑합니다.
                                <br>함께해 주신 모든 <span style="color:#2DB400">소중한 고객</span>에게 감사드립니다.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo1.png" class="w-2">
                                    </div>
                                    <p>서울대학교</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo2.png" class="w-2">
                                    </div>
                                    <p>서울보호관찰소</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo3.png" class="w-2">
                                    </div>
                                    <p>동작구청</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo4.png" class="w-2">
                                    </div>
                                    <p>금천구청</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo5.png" class="w-2">
                                    </div>
                                    <p>관악구청</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo6.png" class="w-2">
                                    </div>
                                    <p>동작르네상스사업단</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo7.png" class="w-2">
                                    </div>
                                    <p>경륜경정총괄본부</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo8.png" class="w-2">
                                    </div>
                                    <p>광진구</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo9.png" class="w-2">
                                    </div>
                                    <p>강남수도사업소</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo10.png" class="w-2">
                                    </div>
                                    <p>용산구청</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo11.png" class="w-2">
                                    </div>
                                    <p>서초구</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo12.png" class="w-2">
                                    </div>
                                    <p>중산고등학교</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo13.png" class="w-2">
                                    </div>
                                    <p>신부종합건설(주)</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo14.png" class="w-2">
                                    </div>
                                    <p>한국농수산식품유통공사</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo15.png" class="w-2">
                                    </div>
                                    <p>노원구청</p>
                                </div>
                                <div class="col-lg-3">
                                    <div class="items-mid">
                                        <img src="img/theme/customer-logo16.png" class="w-2">
                                    </div>
                                    <p>강서구청</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.w-2 {
    max-width: 200px;
    max-height: 200px;
}

.items-mid {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}
</style>
